import { put, call} from 'redux-saga/effects';
import { SignUp } from '../../app/components/SignUp/helper/signUpHelper';
import * as actionTypes from './actionTypes';

export function* signUpSaga(payload){
    try {
        const response = yield call(SignUp, payload.signUp);
        if(response && response){
            yield put({type: actionTypes.SIGN_UP_USER_SUCCESS, response});
        }else{
            yield put({type: actionTypes.SIGN_UP_USER_ERROR, response});
        }
    } catch (error) {
        yield put({type: actionTypes.SIGN_UP_USER_ERROR, error});
    }
}